// Define market-specific routes and precompile regex patterns for dynamic routes
const marketRoutesConfig = {
  wayke: {
    '/': '/',
    '/sitemap.xml': '/sitemap.xml',
    '/skribenter': '/authors',
    '/skribenter/[slug]': '/authors/[slug]',
    '/artiklar': '/articles',
    '/artiklar/sok': '/articles/search',
    '/artiklar/[category]': '/articles/[category]',
    '/artiklar/[category]/[slug]': '/articles/[category]/[slug]',
    '/salj-till-handlare': '/sell-to-dealer',
    '/salj-till-handlare/skapad/[id]': '/sell-to-dealer/created/[id]',
    '/salj-till-handlare/[...slug]': '/sell-to-dealer/[...slug]',
    '/vardera-bil': '/valuate-vehicle',
    '/vardera-bil/[...slug]': '/valuate-vehicle/[...slug]',
    '/auth/signin': '/auth/signin',
    '/oidc/signin': '/oidc/signin',
    '/oidc/signout': '/oidc/signout',
    '/oidc/remove-account': '/oidc/remove-account',
    '/profil/meddelanden/[id]': '/profile/messages/[id]',
    '/profil/meddelanden': '/profile/messages',
    '/profil/varderade-bilar/[id]': '/profile/my-vehicles/[id]',
    '/profil/varderade-bilar': '/profile/my-vehicles',
    '/profil/saljforfragningar': '/profile/assignments',
    '/profil/sparade-bilar': '/profile/vehicle-subscriptions',
    '/profil/bevakningar': '/profile/search-subscriptions',
    '/profil/installningar': '/profile/account',
    '/profil': '/profile',
    '/sok/[[...slug]]': '/search/[[...slug]]',
    '/sok': '/search', // Important that /sok is before /objekt for the sitemap generator
    '/objekt/[[...id]]': '/item/[[...id]]',
    '/objekt': '/search',
    '/kundservice': '/faq',
    '/kundservice/sok': '/faq/search',
    '/kundservice/[category]': '/faq/[category]',
    '/aterforsaljare': '/retailers',
    '/aterforsaljare/[slug]': '/retailers/[slug]',
    '/sentry-example-page': '/sentry-example-page', // should be removed
    '/[slug]': '/[slug]',
  },
  drive: {
    '/': '/',
    '/sitemap.xml': '/sitemap.xml',
    '/forfattere': '/authors',
    '/forfattere/[slug]': '/authors/[slug]',
    // '/artikler': '/articles',
    // '/artikler/sok': '/articles/search',
    // '/artikler/[category]': '/articles/[category]',
    // '/artikler/[category]/[slug]': '/articles/[category]/[slug]',
    '/selg-til-forhandler': '/sell-to-dealer',
    '/selg-til-forhandler/opprettet/[id]': '/sell-to-dealer/created/[id]',
    '/selg-til-forhandler/[...slug]': '/sell-to-dealer/[...slug]',
    '/verdivurdere-bil': '/valuate-vehicle',
    '/verdivurdere-bil/[...slug]': '/valuate-vehicle/[...slug]',
    '/auth/signin': '/auth/signin',
    '/oidc/signin': '/oidc/signin',
    '/oidc/signout': '/oidc/signout',
    '/oidc/remove-account': '/oidc/remove-account',
    '/profil/meldinger/[id]': '/profile/messages/[id]',
    '/profil/meldinger': '/profile/messages',
    '/profil/verdivurderte-biler/[id]': '/profile/my-vehicles/[id]',
    '/profil/verdivurderte-biler': '/profile/my-vehicles',
    '/profil/salgsforesporseler': '/profile/assignments',
    '/profil/lagrede-biler': '/profile/vehicle-subscriptions',
    '/profil/overvakninger': '/profile/search-subscriptions',
    '/profil/innstillinger': '/profile/account',
    '/profil': '/profile',
    '/sok/[[...slug]]': '/search/[[...slug]]',
    '/sok': '/search', // Important that /sok is before /objekt for the sitemap generator
    '/objekt/[[...id]]': '/item/[[...id]]',
    '/objekt': '/search',
    '/kundeservice': '/faq',
    '/kundeservice/sok': '/faq/search',
    '/kundeservice/[category]': '/faq/[category]',
    '/forhandler': '/retailers',
    '/forhandler/[slug]': '/retailers/[slug]',
    '/sentry-example-page': '/sentry-example-page', // should be removed
    '/[slug]': '/[slug]',
  },
} as const;

export type MarketRoutes = keyof typeof marketRoutesConfig;

export default marketRoutesConfig;
